import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';
import VouchersTable from 'src/features/vouchers/components/tables/VouchersTable';

const VouchersLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(voucherTypesMessages.vouchers));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <VouchersTable />;
};

export default VouchersLayout;
